
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { authKey, GET_PO_REPORT, GET_UNLOADER_MAPPING } from '../../common/URLs';
import jwt from 'jwt-decode';
import { DataGrid, GridToolbarFilterButton } from '@mui/x-data-grid';
import { Container, Button, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, Tooltip, CardContent, Grid } from '@mui/material'
import { QuickSearchToolbar } from '../../payment/common/commonFunctions';
import moment from 'moment';
import { loaderService } from "../../common/custom-loader/loader-service";
import { PROD, PIT_ROLES } from "../../common/constants";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { toast } from 'react-toastify';
import Chart from 'react-apexcharts';
import apiClient from "../../axios";
import CustomDataGridToolbar from "../../common/customDataGridToolbar";
import {
    GridToolbarContainer,
    GridToolbarQuickFilter,
    useGridApiContext,
    useGridSelector,
    gridFilteredSortedRowEntriesSelector,
} from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import { DownloadIcon } from "../../common/icons";

function PoReport() {

    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [poReportDetails, setPoReportDetails] = useState();
    const [typeCount, setTypeCount] = useState();

    useEffect(() => {
        getPoReport();
    }, []);

    const getPoReport = () => {
        loaderService.showLoader()
        apiClient
            .post(
                GET_PO_REPORT,
                {
                    "stakeholderType": "",
                    "stakeholderUrn": "",
                    "poType": "",
                    "serviceStakeholderType": ""
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setPoReportDetails(response.data.poReportList);
                setTypeCount(response.data.poReportChartData);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
                // toast.error(error.message);

            });
    };


    const columns = [
        { field: 'poNumber', headerName: 'PO Number', width: 130 },
        {
            field: 'createdOn', headerName: 'PO Date', width: 140,
            valueFormatter: (params) => {
                if (!moment(params.value, moment.ISO_8601, true).isValid()) {
                    // console.log("Bad createdOn:", params.value, params.row);
                    return "";
                }
                return moment(params.value).format("DD/MM/YYYY");
            }
        },
        { field: 'poStakeholderUrn', headerName: 'PO Stakeholder URN', width: 150 },
        { field: 'poStakeholderType', headerName: 'PO Stakeholder Type', width: 150 },
        { field: 'poStakeholderName', headerName: 'PO Stakeholder Name', width: 180 },
        { field: 'destinationStakeholderUrn', headerName: 'Destination Stakeholder URN', width: 200 },
        { field: 'destinationStakeholderName', headerName: 'Destination Stakeholder Name', width: 220 },
        { field: 'sapVendorId', headerName: 'SAP Vendor ID', width: 160 },
        { field: 'sapPoNumber', headerName: 'SAP PO Number', width: 160 },
        { field: 'poUnitPrice', headerName: 'Unit Rate(INR)', width: 150, },
        { field: 'poUnitOfMeasure', headerName: 'UOM', width: 100 },
        { field: 'poQuantity', headerName: 'PO Quantity(MT)', width: 150 },
        { field: 'grnQuantity', headerName: 'GRN Quantity(MT)', width: 150 },
        { field: 'poBalanceQuantityAfterGrn', headerName: 'PO Balance Quantity(MT)', width: 170 },
        { field: 'scheduleQuantity', headerName: 'Schedule Quantity(MT)', width: 170 },
        { field: 'scheduleBalanceQuantity', headerName: 'Schedule Balance Quantity(MT)', width: 180 },
        { field: 'totalInvoiceGenerated', headerName: 'Total Invoice Generated(INR)', width: 180 },
        { field: 'totalInvoicePaid', headerName: 'Total Invoice Paid(INR)', width: 180 },

    ];

    const sTypeCount = typeCount?.stakeholderPOCountList;
    const stakeholderTypes =
        typeCount?.stakeholderPOGrnQuantitiesList?.map(
            r => r.stakeholderType
        ) || [];

    const poGrnMap = {};
    typeCount?.stakeholderPOGrnQuantitiesList?.forEach(r => {
        poGrnMap[r.stakeholderType] = r;
    });

    const invoiceMap = {};
    typeCount?.stakeholderInvoiceAmountsList?.forEach(r => {
        invoiceMap[r.stakeholderType] = r;
    });

    const categories = typeCount?.stakeholderPOGrnQuantitiesList ? typeCount?.stakeholderPOGrnQuantitiesList?.map(r => r.stakeholderType) : [];

    const series = [
        {
            name: "PO Quantity",
            data: stakeholderTypes.map(
                t => Number(poGrnMap[t]?.poQuantity ?? 0)
            )
        },
        {
            name: "GRN Quantity",
            data: stakeholderTypes.map(
                t => Number(poGrnMap[t]?.grnQuantity ?? 0)
            )
        }
    ];

    const seriesInvoice = [
        {
            name: "Invoice Amount",
            data: stakeholderTypes.map(
                t => Number(invoiceMap[t]?.invoiceAmount ?? 0)
            )
        },
        {
            name: "Paid Invoice Amount",
            data: stakeholderTypes.map(
                t => Number(invoiceMap[t]?.invoiceAmountPaid ?? 0)
            )
        }
    ];


    const options = {
        chart: {
            type: "bar",
            toolbar: { show: true },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "55%",
                borderRadius: 6,
                dataLabels: {
                    position: "top", // or "center" for inside the bar
                },
            },
        },
        dataLabels: {
            enabled: true,
            distributed: false, // labels follow series color
            style: {
                fontSize: "11px",
                colors: ["#200404ff"], // force white text if inside colored bar
            },
            formatter: (val) =>
                Number(val).toLocaleString(undefined, { maximumFractionDigits: 2 }),
            offsetY: -2,
        },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: {
            categories: stakeholderTypes,
            title: { text: "Stakeholder Type" },
        },
        yaxis: {
            title: { text: "Quantity" },
            labels: { formatter: (v) => Number(v).toLocaleString() },
        },
        tooltip: {
            y: {
                formatter: (v) =>
                    Number(v).toLocaleString(undefined, { maximumFractionDigits: 3 }),
            },
        },
        legend: { position: "top" },
        grid: { strokeDashArray: 4 },
        fill: { opacity: 1 },
    };

    // const seriesInvoice = [
    //     { name: "Invoice Amount", data: typeCount?.stakeholderInvoiceAmountsList ? typeCount?.stakeholderInvoiceAmountsList?.map(r => Number(r.invoiceAmount ?? 0)) : [] },
    //     { name: "Paid Invoice Amount", data: typeCount?.stakeholderInvoiceAmountsList ? typeCount?.stakeholderInvoiceAmountsList?.map(r => Number(r.invoiceAmountPaid ?? 0)) : [] },
    // ];

    const optionsInvoice = {
        chart: {
            type: "bar",
            toolbar: { show: true },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "55%",
                borderRadius: 6,
                dataLabels: {
                    position: "top", // or "center" for inside the bar
                },
            },
        },
        dataLabels: {
            enabled: true,
            distributed: false, // labels follow series color
            style: {
                fontSize: "11px",
                colors: ["#200404ff"], // force white text if inside colored bar
            },
            formatter: (val) =>
                Number(val).toLocaleString(undefined, { maximumFractionDigits: 2 }),
            offsetY: -2,
        },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: {
            categories: stakeholderTypes,
            title: { text: "Stakeholder Type" },
        },
        yaxis: {
            title: { text: "Amount (INR)" },
            labels: { formatter: (v) => Number(v).toLocaleString() },
        },
        tooltip: {
            y: {
                formatter: (v) =>
                    Number(v).toLocaleString(undefined, { maximumFractionDigits: 3 }),
            },
        },
        legend: { position: "top" },
        grid: { strokeDashArray: 4 },
        fill: { opacity: 1 },
    };

    function CustomDataGridToolbarPoReport({ fileName = "PO_Report.xlsx" }) {
        const apiRef = useGridApiContext();

        const visibleRowEntries = useGridSelector(
            apiRef,
            gridFilteredSortedRowEntriesSelector
        );

        // Convert JS Date -> Excel serial number (guarantees Year/Month grouping)
        const toExcelSerial = (dateObj) => {
            const excelEpoch = new Date(Date.UTC(1899, 11, 30)); // 1899-12-30
            const utcDate = new Date(
                Date.UTC(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate())
            );
            return (utcDate - excelEpoch) / (24 * 60 * 60 * 1000);
        };

        const exportExcel = () => {
            const cols = apiRef.current
                .getAllColumns()
                .filter((c) => !c.hide && c.field !== "actions" && c.field !== "__check__");

            // 1) Build data like you already do (keep header names)
            const data = visibleRowEntries.map(({ model }) => {
                const obj = {};
                cols.forEach((c) => {
                    obj[c.headerName || c.field] = model[c.field] ?? "";
                });
                return obj;
            });

            // 2) Create worksheet normally
            const ws = XLSX.utils.json_to_sheet(data);

            // 3) Find which column index is the createdOn column in the exported sheet
            const createdOnColIndex = cols.findIndex((c) => c.field === "createdOn");
            if (createdOnColIndex !== -1) {
                const createdOnColLetter = XLSX.utils.encode_col(createdOnColIndex); // e.g. "B"

                // 4) For every row (data starts at row 2 because row 1 is headers)
                data.forEach((rowObj, i) => {
                    const rowNumber = i + 2; // Excel is 1-based, header is row 1
                    const cellAddr = `${createdOnColLetter}${rowNumber}`;

                    // raw ISO string from your backend
                    const raw = rowObj[cols[createdOnColIndex].headerName || "createdOn"];

                    // parse ISO safely (your example: 2025-12-09T12:08:35.073)
                    const d = moment(raw, moment.ISO_8601, true).toDate();

                    if (raw && !isNaN(d.getTime())) {
                        ws[cellAddr] = {
                            t: "n",                 // numeric type (IMPORTANT for grouping)
                            v: toExcelSerial(d),    // excel date serial
                            z: "dd/mm/yyyy",        // display format
                        };
                    } else {
                        ws[cellAddr] = { t: "s", v: "" };
                    }
                });
            }

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Data");
            XLSX.writeFile(wb, fileName, { bookType: "xlsx" });
        };

        return (
            <GridToolbarContainer sx={{ display: "flex", alignItems: "center", px: 1 }}>
                <Button startIcon={<DownloadIcon />} onClick={exportExcel}>
                    Export Excel
                </Button>

                <Box sx={{ flexGrow: 1 }} />

                <Box onKeyDownCapture={(e) => e.stopPropagation()}>
                    <GridToolbarQuickFilter debounceMs={300} />
                </Box>
            </GridToolbarContainer>
        );
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT80</p>}
                {/* <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between"> */}
                <Typography variant="h4" gutterBottom >
                    PO Report
                </Typography>
                {/* </Stack> */}
                <Grid container spacing={1}>
                    <Grid item xs={12} lg={12}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Stakeholder PO
                                </Typography>
                                <Chart
                                    type="pie"
                                    width="100%"
                                    height={250}
                                    style={{ align: "center" }}
                                    series={sTypeCount ? [sTypeCount?.[0]?.count ? sTypeCount?.[0]?.count : 0, sTypeCount?.[1]?.count ? sTypeCount?.[1]?.count : 0, sTypeCount?.[2]?.count ? sTypeCount?.[2]?.count : 0, sTypeCount?.[3]?.count ? sTypeCount?.[3]?.count : 0, sTypeCount?.[4]?.count ? sTypeCount?.[4]?.count : 0] : []}
                                    options={
                                        {
                                            labels: sTypeCount ? [sTypeCount?.[0]?.stakeholderType ? sTypeCount?.[0]?.stakeholderType : "",
                                            sTypeCount?.[1]?.stakeholderType ? sTypeCount?.[1]?.stakeholderType : "",
                                            sTypeCount?.[2]?.stakeholderType ? sTypeCount?.[2]?.stakeholderType : "",
                                            sTypeCount?.[3]?.stakeholderType ? sTypeCount?.[3]?.stakeholderType : "",
                                            sTypeCount?.[4]?.stakeholderType ? sTypeCount?.[4]?.stakeholderType : ""] : [],

                                            dataLabels: {
                                                enabled: true,
                                                formatter: (val, opts) =>
                                                    opts.w.globals.series[opts.seriesIndex],   // show actual value
                                                style: { fontSize: '13px', colors: ["#443939ff"] },
                                                dropShadow: { enabled: false },
                                                background: { enabled: false },
                                            },
                                            plotOptions: {
                                                pie: {
                                                    dataLabels: {
                                                        offset: 35,          // <-- push labels OUTSIDE (try 24–40)
                                                    },
                                                    // optional: hide tiny-slice labels to avoid overlap
                                                    // minAngleToShowLabel: 5
                                                }
                                            },
                                            legend: { position: 'right' },
                                            // avoid clipping at the edges
                                            chart: {
                                                parentHeightOffset: 0,  // avoid extra trimming
                                                offsetY: 10,            // move whole chart down a bit (tweak as needed)
                                            },
                                            grid: {
                                                // real margin inside SVG so outside labels are visible
                                                padding: { top: 18, right: 18, bottom: 18, left: 18 },
                                            },

                                        }}>
                                </Chart>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Card sx={{ p: 2, borderRadius: 3, boxShadow: 3 }}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Stakeholder Quantities (PO vs GRN)
                                </Typography>
                                <Chart options={options} series={series} type="bar" height={260} />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Card sx={{ p: 2, borderRadius: 3, boxShadow: 3 }}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Stakeholder Invoice
                                </Typography>
                                <Chart options={optionsInvoice} series={seriesInvoice} type="bar" height={260} />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Box sx={{ height: 450, width: "100%" }}>
                            {
                                poReportDetails &&
                                <DataGrid rows={poReportDetails}
                                    sx={{
                                        '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                                        '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                                        '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' },
                                    }}
                                    getRowHeight={(e) => 'auto'}
                                    columns={columns}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    // pageSize={10}
                                    getRowId={(row) => row.poNumber}
                                    disableColumnFilter={false}
                                    components={{ Toolbar: CustomDataGridToolbarPoReport }}
                                    componentsProps={{ toolbar: { fileName: "PO_Report.xlsx" } }}
                                    // components={{ Toolbar: CustomDataGridToolbar }}
                                    // componentsProps={{ toolbar: { rows: poReportDetails, columns: columns, fileName: "PO_Report.xlsx", isExportToExcelRequired: true } }}
                                    experimentalFeatures={{ newEditingApi: true }}
                                />
                            }
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}
export default PoReport;
